<div
  class="shared-layout-container"
  [ngStyle]="{
    '--left-sidebar-width': leftSidebarWidth
  }">
  <ng-content select="left-sidebar"></ng-content>
  <div
    class="tabs-container"
    [ngStyle]="{ 'margin-bottom': tabs.length > 0 ? '0.5rem' : '0' }"
    appHorizontalScroll>
    @for (tab of tabs; track trackTabByTabName($index, tab)) {
      <div
        class="tab"
        [class.active]="tab === selectedTab"
        (click)="onSelectedTabChange(tab)"
        (keydown.enter)="onSelectedTabChange(tab)"
        (keydown.space)="onSelectedTabChange(tab)"
        role="button"
        [attr.tabindex]="tab !== selectedTab ? '0' : '-1'">
        <app-shared-button type="button" class="tab-button" tabindex="-1" [fill]="tab === selectedTab">
          {{ tab }}
        </app-shared-button>
      </div>
    }
  </div>
  <ng-content select="main-content"></ng-content>
</div>
